// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","navbar__logo":"Navbar_navbar__logo__mbHX7","navbar__text":"Navbar_navbar__text__CeSQq"};